// theme
import palette from '../theme/palette';

// ----------------------------------------------------------------------

export const colorPresets = [
  // DEFAULT
  {
    name: 'default',
    ...palette.light.primary,
  },
  // BLUE
  {
    name: 'blue',
    lighter: '#56019137',
    light: '#81019137',
    main: '#019137',
    dark: '#007128',
    darker: '#5A00762A',
    contrastText: '#fff',
  },
];

export const defaultPreset = colorPresets[0];
export const bluePreset = colorPresets[1];

export default function getColorPresets(presetsKey) {
  return {
    blue: bluePreset,
    default: defaultPreset,
  }[presetsKey];
}
